import { select } from '@js/util/select.js'
import $ from 'jquery'

select('.popup-wrap', element => {
  let $wrap = $(element)
  let uid = $wrap.data('uid')

  let activeClass = 'active'
  let closeButton = $wrap.find('.close-button')
  let open = function () {
    $wrap.addClass(activeClass)
  }
  let close = function () {
    $wrap.removeClass(activeClass)
    history.replaceState({}, document.title, window.location.href.split('#')[0])
  }
  closeButton.on('click', close)
  if (window.location.hash.slice(1) === uid) {
    open()
  }

  $(window).on('hashchange', function (e) {
    let hash = window.location.hash.slice(1)
    if (hash === uid) {
      open()
    } else {
      if ($wrap.hasClass(activeClass)) {
        close()
      }
    }
  })
})
